import { createSceneReducer } from 'reducers/reducers-util';
import serviceProvidersUIReducer from 'components/admin/service-providers/store/reducers.ui';

export default createSceneReducer(null, serviceProvidersUIReducer);
